import React from 'react';

interface Props {
  score: number;
  total: number;
  levelTitle: string;
  /** Whether there's a next level to unlock */
  hasNext: boolean;
  onNext: () => void;
  onRetry: () => void;
}

export const QuizResults: React.FC<Props> = ({
  score,
  total,
  levelTitle,
  hasNext,
  onNext,
  onRetry,
}) => {
  const pct = Math.round((score / total) * 100);
  const isPassing = pct >= 60;

  return (
    <div className="flex flex-col items-center justify-center gap-6 py-8 text-center">
      {/* Score circle */}
      <div
        className={`w-24 h-24 rounded-full flex items-center justify-center text-3xl font-bold font-mono border-4 ${
          isPassing
            ? 'border-[var(--clue-green-accent)] text-[var(--clue-green-accent)]'
            : 'border-amber-400 text-amber-400'
        }`}
      >
        {pct}%
      </div>

      <div>
        <h3 className="text-lg font-semibold font-serif text-[var(--clue-text-primary)]">
          {isPassing ? 'Great job!' : 'Keep learning!'}
        </h3>
        <p className="text-sm text-[var(--clue-text-secondary)] mt-1">
          You scored {score}/{total} on <span className="font-medium">{levelTitle}</span>
        </p>
      </div>

      <div className="flex flex-col gap-2 w-full max-w-xs">
        {isPassing && (
          <button
            onClick={onNext}
            className="h-11 rounded-lg bg-[var(--clue-green-accent)] text-white text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            {hasNext ? 'Next Level' : 'Back to Overview'}
          </button>
        )}
        <button
          onClick={isPassing ? onNext : onRetry}
          className={`h-11 rounded-lg border text-sm font-medium transition-colors ${
            isPassing
              ? 'border-[var(--clue-border-mid)] text-[var(--clue-text-secondary)] hover:bg-[var(--clue-bg-secondary)]'
              : 'bg-[var(--clue-green-accent)] text-white hover:opacity-90'
          }`}
        >
          {isPassing ? 'Back to Course' : 'Try Again'}
        </button>
      </div>
    </div>
  );
};
